import usePaidCourses from "../../hooks/usePaidCourses";
import React from "react";
const PurchaseCourses = () => {
  const { courses ,loading} = usePaidCourses();

  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const formatPrice = (price) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    }).format(price);
  };
  const renderSkeleton = () => {
    return (
      <tr>
        <td className="px-4 py-4"><div className="w-16 h-16 bg-gray-200 rounded-lg animate-pulse" /></td>
        <td className="px-4 py-4"><div className="h-4 bg-gray-200 rounded animate-pulse w-32" /></td>
        <td className="px-4 py-4"><div className="h-4 bg-gray-200 rounded animate-pulse w-24" /></td>
        <td className="px-4 py-4"><div className="h-4 bg-gray-200 rounded animate-pulse w-20" /></td>
        <td className="px-4 py-4"><div className="h-4 bg-gray-200 rounded animate-pulse w-36" /></td>
        <td className="px-4 py-4"><div className="h-4 bg-gray-200 rounded animate-pulse w-28" /></td>
        <td className="px-4 py-4"><div className="h-4 bg-gray-200 rounded animate-pulse w-28" /></td>
      </tr>
    );
  };
  return (
    <div className="mt-6 md:mt-0 md:p-6">
       <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
          <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
          </svg>
        </div>
        <div>
          <h1 className="text-2xl font-semibold text-gray-900">Purchased Courses</h1>
          <p className="text-sm text-gray-500 mt-0.5">Manage and access your materials</p>
        </div>
      </div>
      {/* TABLE LAYOUT */}
      <div className="bg-white rounded-2xl border border-gray-200 overflow-hidden">
         <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="border-b border-gray-200">
              <th className="text-left py-3 px-6 text-sm font-semibold text-gray-700">Thumbnail</th>
              <th className="text-left py-3 px-6 text-sm font-semibold text-gray-700">Course Title</th>
              <th className="text-left py-3 px-6 text-sm font-semibold text-gray-700">Instructor</th>
              <th className="text-left py-3 px-6 text-sm font-semibold text-gray-700">Course Type</th>
              <th className="text-left py-3 px-6 text-sm font-semibold text-gray-700">Price Paid</th>
              <th className="text-left py-3 px-6 text-sm font-semibold text-gray-700">Transaction ID</th>
              <th className="text-left py-3 px-6 text-sm font-semibold text-gray-700">Purchase Date</th>
            </tr>
          </thead>

          <tbody>
            { loading
                            ? Array(3).fill(0).map((_, index) => <React.Fragment key={index}>{renderSkeleton()}</React.Fragment>)
                            :courses?.filter(
                (item) =>
                  (item.learning_type === "course" && item.course !== null) ||
                  (item.learning_type === "video" && item.video !== null) ||
                  (item.learning_type === "audio" && item.audio !== null) ||
                  (item.learning_type === "podcast" && item.podcast !== null)
              )
              .map((course) => (
                <tr key={course.id} className="border-b border-gray-100 hover:bg-gray-50 transition-colors">
                  {/* COURSE */}
                  {course.learning_type === "course" && (
                    <>
                      <td className="py-4 px-6">
                        <img
                          src={course.course.image}
                          className="w-16 h-16 rounded-lg object-cover"
                          alt={course.course.name || "thumb"}
                        />
                      </td>
                      <td className="py-4 px-6">{course.course.name}</td>
                      <td className="py-4 px-6">{course.course.teacher_name}</td>
                      <td className="py-4 px-6">{"course"}</td>
                      <td className="py-4 px-6">{formatPrice(course.course.price)}</td>
                    </>
                  )}

                  {/* VIDEO */}
                  {course.learning_type === "video" && (
                    <>
                      <td className="py-4 px-6">
                        <video
                          src={course.video.file}
                          className="w-16 h-16 rounded-lg object-cover"
                          controls
                        />
                      </td>
                      <td className="py-4 px-6">{course.video.name}</td>
                      <td className="py-4 px-6">{course.video.teacher_name}</td>
                      <td className="py-4 px-6">{"video"}</td>
                      <td className="py-4 px-6">{formatPrice(course.video.price)}</td>
                    </>
                  )}

                  {/* AUDIO */}
                  {course.learning_type === "audio" && (
                    <>
                      <td className="py-4 px-6">
                        {course.audio.file ? (
                          <audio
                            src={course.audio.file}
                            controls
                            className="w-16 h-16 rounded-lg object-cover"
                          />
                        ) : course.audio.image ? (
                          <img
                            src={course.audio.image}
                            className="w-16 h-16 rounded-lg object-cover"
                            alt="thumb"
                          />
                        ) : null}
                      </td>
                      <td className="py-4 px-6">{course.audio.name}</td>
                      <td className="py-4 px-6">{course.audio.teacher_name}</td>
                      <td className="py-4 px-6">{"audio"}</td>
                      <td className="py-4 px-6">{formatPrice(course.audio.price)}</td>
                     
                    </>
                  )}

                  {/* PODCAST */}
                  {course.learning_type === "podcast" && (
                    <>
                      <td className="py-4 px-6">
                        {course.podcast.file ? (
                          <video
                            src={course.podcast.file}
                            controls
                            className="w-16 h-16 rounded-lg object-cover"
                          />
                        ) : course.podcast.image ? (
                          <img
                            src={course.podcast.image}
                            className="w-16 h-16 rounded-lg object-cover"
                            alt="thumb"
                          />
                        ) : null}
                      </td>
                      <td className="py-4 px-6">{course.podcast.name}</td>
                      <td className="py-4 px-6">{course.podcast.teacher_name}</td>
                      <td className="py-4 px-6">{"podcast"}</td>
                      <td className="py-4 px-6">{formatPrice(course.podcast.price)}</td>
                    
                    </>
                  )}

                  {/* Order ID rendered outside all type-specific conditions */}
                  <td className="py-4 px-6">{course.order_id}</td>
                  <td className="py-4 px-6">{formatDate(course.created_at)}</td>
                </tr>
              ))}
          </tbody>
        </table>
         </div>
      </div>
        {!loading && courses.length === 0 && (
        <div className="mt-6 border-2 border-dashed border-gray-300 rounded-2xl p-12 text-center">
          <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
            </svg>
          </div>
          <h3 className="text-lg font-medium text-gray-700 mb-2">No purchases yet</h3>
          <p className="text-sm text-gray-500">When students purchase your courses, they'll appear here.</p>
        </div>
      )}
    </div>
  );
};

export default PurchaseCourses;
